import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { upcomingWorkshops } from '../../data/homeContent';
import { contact } from '../../data/site';
export function WorkshopsSection() {
  return <section aria-labelledby="ateliers-title" className="border-t border-line" data-id="element-86" data-mp="2ujkya8bxpxya">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 py-24 lg:grid-cols-12 lg:gap-16 lg:px-10 lg:py-32" data-id="element-87" data-mp="2zlacfwugerql">
        <figure className="lg:col-span-6" data-id="element-88" data-mp="33l2hw0ojwhrq">
          <img src={contact.workshopImage} alt="Trois violoncellistes en atelier, l’une étirant ses épaules entre deux passages" className="aspect-[4/3] w-full rounded-sm object-cover" data-id="element-89" data-mp="38kxaq9rvzhff" />
          <figcaption className="mt-4 text-sm text-ink-soft" data-id="element-90" data-mp="3ib05ofikj5ge">
            Atelier « Le dos, les épaules et l’archet »
          </figcaption>
        </figure>

        <div className="flex flex-col lg:col-span-6" data-id="element-91" data-mp="3n809ejry3w4c">
          <h2 id="ateliers-title" className="font-display text-4xl font-medium leading-tight md:text-5xl" data-id="element-92" data-mp="3rc802mhyrm57">
            Ateliers & stages
          </h2>
          <p className="mt-6 max-w-lg leading-relaxed text-ink-soft" data-id="element-93" data-mp="24nfxi2fu1crw">
            En groupe, sur une journée ou une semaine : préparation à la scène, prévention des douleurs,
            musique de chambre. Également proposés aux conservatoires, écoles de musique et orchestres.
          </p>

          <h3 className="mt-12 text-sm font-medium text-ink" data-id="element-94" data-mp="2sd0sxkt6a2i2">Prochaines dates</h3>
          <ul className="mt-4" data-id="element-95" data-mp="2sf3ffuv49di1">
            {upcomingWorkshops.map(w => <li key={w.title} className="grid gap-1 border-t border-line py-5 sm:grid-cols-[9rem_1fr] sm:gap-6" data-id="element-96" data-mp="2nefqdeqg76qg">
                <span className="text-sm font-medium text-wood" data-id="element-97" data-mp="2il4hl822sfvw">{w.date}</span>
                <span data-id="element-98" data-mp="2dnl5adoxud6l">
                  <span className="block font-display text-xl font-medium leading-snug" data-id="element-99" data-mp="2dm1n2hjq1s26">{w.title}</span>
                  <span className="text-sm text-ink-soft" data-id="element-100" data-mp="3b5ctq346gvq3">{w.audience}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-auto flex flex-wrap gap-x-8 gap-y-4 border-t border-line pt-8" data-id="element-101" data-mp="14ezspj3654lt">
            <Link to="/ateliers" className="inline-flex items-center gap-2 text-sm font-medium text-ink transition-colors duration-150 hover:text-wood" data-id="element-102" data-mp="19em2fijsg2pv">
              Tous les ateliers
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-103" data-mp="zmyh7zdtrhwu" />
            </Link>
            <Link to="/contact" className="text-sm font-medium text-ink-soft transition-colors duration-150 hover:text-wood" data-id="element-104" data-mp="lnyskrqbb30o">
              Organiser un atelier dans votre structure
            </Link>
          </div>
        </div>
      </div>
    </section>;
}